import { Select, Input, DatePicker, InputNumber } from "antd";
import "./internalErrorRca.css";
import TextArea from "antd/lib/input/TextArea";
import { useContext, useEffect, useState } from "react";
import { GlobalStateContext } from "../../../utils/GlobalStateContext";
import { internalErrorRca } from "../../../utils/Constants";
import moment from "moment";

const onSearch = (value) => {};

const InternalErrorRcaForm = ({
  selectedAudit,
  erroronweekdayweekend,
  dayoftheweek,
}) => {
  const { globalState, setGlobalState } = useContext(GlobalStateContext);

  const [isValidEmail, setIsValidEmail] = useState(true);

  const handleEmailChange = (event) => {
    const enteredEmail = event.target.value;
    if (enteredEmail) {
      // Regular expression for basic email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      setIsValidEmail(emailRegex.test(enteredEmail));
      setGlobalState((prevGlobalState) => {
        const newGlobalState = {
          ...prevGlobalState,
          eClientSpocEmailVal: "",
          eClientSpocEmail: emailRegex.test(enteredEmail),
        };
        return newGlobalState;
      });
    } else {
      setIsValidEmail("false");
    }
  };

  const disableFutureDates = (current) => {
    const startDate = moment(current).subtract(1, "month").startOf("day");

    // Calculate the end date for the next financial year
    const currentYear = moment().year();
    const nextFinancialYearEnd = moment()
      .month(2)
      .date(31)
      .year(
        currentYear + (moment().isAfter(moment().month(2).date(31)) ? 1 : 0)
      )
      .endOf("day");

    // Disable dates outside the range two months ago from today to next financial year's 31st March
    return (
      current &&
      (current.isBefore(startDate) || current.isAfter(moment().endOf("day")))
    );
  };

  useEffect(() => {
    setGlobalState((prevGlobalState) => {
      const newGlobalState = {
        ...prevGlobalState,
        auditID: selectedAudit?.id,
        eErroronweekdayweekendVal: erroronweekdayweekend || null,
        eDayoftheweekVal: dayoftheweek || null,
      };
      return newGlobalState;
    });
  }, [selectedAudit]);

  return (
    <div id="antdformstyle">
      {internalErrorRca.map((section) => (
        <div key={section.key}>
           <div className="pb-16 cusFormTitle">{section.title}</div>
          <div className="details-container plr-16">
            {section.key === "rcaDetails"
              ? section.fields
                  .reduce((rows, field, index) => {
                    if (index % 2 === 0) {
                      rows.push(section.fields.slice(index, index + 2));
                    }
                    return rows;
                  }, [])
                  .map((fieldPair, pairIndex) => (
                    <div className="details-wrap" key={pairIndex}>
                      {fieldPair.map((field, i) => {
                        // Logic for RCA only
                        const shouldShow =
                          field.key === "rcaLevelOne" ||
                          (field.key === "rcaLevelTwo" &&
                            globalState?.rcaLevelOneVal) ||
                          (field.key === "rcaLevelThree" &&
                            globalState?.rcaLevelTwoVal) ||
                          (field.key === "rcaLevelFour" &&
                            globalState?.rcaLevelThreeVal);

                        if (!shouldShow) return null;

                        let options = field.options;
                        if (field.optionsByParent) {
                          const parentKey =
                            field.key === "rcaLevelTwo"
                              ? globalState?.rcaLevelOne
                              : field.key === "rcaLevelThree"
                              ? globalState?.rcaLevelTwo
                              : field.key === "rcaLevelFour"
                              ? globalState?.rcaLevelThree
                              : null;

                          options = parentKey
                            ? field.optionsByParent[
                                parentKey
                                  .toLowerCase()
                                  .replace(/[^a-z0-9]/g, "")
                              ] || []
                            : [];
                        }

                        return (
                          <div key={field.key} className="details-inner">
                            <label className="formCusLabel">{field.label}</label>
                            <Select
                              showSearch
                              allowClear
                              placeholder={field.placeholder}
                              options={options}
                              value={globalState?.[`${field.key}Val`]}
                              onChange={(val, option) => {
                                setGlobalState((prev) => ({
                                  ...prev,
                                  [`${field.key}Val`]: option?.label,
                                  [field.key]: val || field.errorMessage,

                                  ...(field.key === "rcaLevelOne" && {
                                    rcaLevelTwo: null,
                                    rcaLevelTwoVal: null,
                                    rcaLevelThree: null,
                                    rcaLevelThreeVal: null,
                                    rcaLevelFour: null,
                                    rcaLevelFourVal: null,
                                  }),
                                  ...(field.key === "rcaLevelTwo" && {
                                    rcaLevelThree: null,
                                    rcaLevelThreeVal: null,
                                    rcaLevelFour: null,
                                    rcaLevelFourVal: null,
                                  }),
                                  ...(field.key === "rcaLevelThree" && {
                                    rcaLevelFour: null,
                                    rcaLevelFourVal: null,
                                  }),
                                }));
                              }}
                            />

                            {globalState?.[`${field.key}`] ===
                              field.errorMessage && (
                              <div className="error">{field.errorMessage}</div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  ))
              : section.fields
                  .reduce((rows, field, index) => {
                    // Group into pairs
                    if (index % 2 === 0) {
                      rows.push(section.fields.slice(index, index + 2));
                    }
                    return rows;
                  }, [])
                  .map((fieldPair, pairIndex) => (
                    <div className="details-wrap" key={pairIndex}>
                      {fieldPair.map((field) => (
                        <div key={field.key} className="details-inner">
                          <label className="formCusLabel">{field.label}</label>
                          {field.type === "input" && (
                            <Input
                              placeholder={field.placeholder}
                              value={globalState?.[`${field.key}Val`]}
                              onChange={(e) => {
                                if (field.validate === "email") {
                                  handleEmailChange(e);
                                }
                                setGlobalState((prev) => ({
                                  ...prev,
                                  [`${field.key}Val`]: e.target.value,
                                  [field.key]:
                                    e.target.value || field.errorMessage,
                                }));
                              }}
                            />
                          )}
                          {field.type === "number" && (
                            <InputNumber
                              placeholder={field.placeholder}
                              value={globalState?.[`${field.key}Val`]}
                              onChange={(value) => {
                                setGlobalState((prev) => ({
                                  ...prev,
                                  [`${field.key}Val`]: value,
                                  [field.key]: value || field.errorMessage,
                                }));
                              }}
                            />
                          )}
                          {field.type === "date" && (
                            <DatePicker
                              disabledDate={disableFutureDates}
                              placeholder={field.placeholder}
                              value={globalState?.[`${field.key}Val`]}
                              onChange={(date) => {
                                const dayName = date ? date.format("ddd") : "";

                                setGlobalState((prev) => ({
                                  ...prev,
                                  [`${field.key}Val`]: date,
                                  [field.key]: date || field.errorMessage,
                                  ...(field.key === "eTransactionDate"
                                    ? { eDayoftheweekVal: dayName || null }
                                    : {}),
                                }));
                              }}
                            />
                          )}
                          {field.type === "readonly" && (
                            <div className="readonly-field">
                              <span>
                                {field.key === "eErroronweekdayweekend"
                                  ? erroronweekdayweekend
                                  : field.key === "eDayoftheweek"
                                  ? dayoftheweek
                                  : globalState?.[`${field.key}Val`]}
                              </span>
                            </div>
                          )}
                          {field.type === "textarea" && (
                            <TextArea
                              placeholder={field.placeholder}
                              value={globalState?.[`${field.key}Val`]}
                              onChange={(e) =>
                                setGlobalState((prev) => ({
                                  ...prev,
                                  [`${field.key}Val`]: e.target.value,
                                  [field.key]:
                                    e.target.value || field.errorMessage,
                                }))
                              }
                            />
                          )}
                          {field.type === "select" && (
                            <Select
                              showSearch
                              allowClear
                              placeholder={field.placeholder}
                              optionFilterProp="children"
                              value={globalState?.[`${field.key}Val`]}
                              onChange={(val, option) => {
                                setGlobalState((prev) => ({
                                  ...prev,
                                  [`${field.key}Val`]: option?.label,
                                  [field.key]: val || field.errorMessage,
                                }));
                              }}
                              onSearch={onSearch}
                              filterOption={(input, option) =>
                                (option?.label ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              options={field.options}
                            />
                          )}

                          {globalState?.[`${field.key}`] ===
                            field.errorMessage && (
                            <div className="error">{field.errorMessage}</div>
                          )}
                          {field.validate === "email" && !isValidEmail && (
                            <div className="error">
                              Please enter a valid email address.
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  ))}
          </div>
        </div>
      ))}
    </div>
  );
};
export default InternalErrorRcaForm;
